var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMomentumStrongPositive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.79 12.415c0-.766.589-1.415 1.415-1.415h10.38c.766 0 1.415.649 1.415 1.415v10.38c0 .826-.649 1.416-1.415 1.416-.826 0-1.416-.59-1.416-1.416v-6.959L22.905 27.101c-.59.59-1.475.59-2.006 0l-6.546-6.547-8.905 8.906c-.59.59-1.475.59-2.006 0a1.292 1.292 0 010-1.947l9.908-9.967c.531-.53 1.416-.53 1.947 0l6.546 6.547 10.32-10.262h-6.958c-.826 0-1.416-.59-1.416-1.416z"
  })));
}
export default SvgMomentumStrongPositive;